/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import { numericPercentages } from "../../../../../global/emotion";

const childrenStyle: Interpolation = {
  left: numericPercentages[50],
  position: "absolute",
  top: numericPercentages[50],
  transform: "translate(-50%, -50%)",
};
const innerStyle: Interpolation = {
  display: "flex",
  position: "relative",
};

export type WeirdStarWithChildrenProps = {
  children?: ReactNode;
  childrenCSS?: Interpolation;
  adaptiveSize?: boolean;
  className?: string;
};

export const WeirdStarWithChildren = ({
  children,
  childrenCSS = {},
  adaptiveSize = true,
  className = "",
}: WeirdStarWithChildrenProps) => {
  const [bound, setBound] = useState<number>(64);
  const childWrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (childWrapper.current) {
      const box = childWrapper.current.getBoundingClientRect();
      setBound(Math.max(box.width, box.height) + 18);
    }
  }, []);

  return (
    <div className={className}>
      <div css={innerStyle}>
        <svg
          fill="none"
          height={adaptiveSize ? bound : 64}
          width={adaptiveSize ? bound : 64}
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M38.8203 1.72811C39.6756 1.35497 40.6752 1.62282 41.2293 2.37359L43.8413 5.91268C44.2261 6.43416 44.8399 6.73681 45.4879 6.72469L49.8857 6.64245C50.8186 6.62501 51.6397 7.25501 51.8643 8.16067L52.9231 12.4299C53.0791 13.059 53.5303 13.5735 54.1336 13.8102L58.2281 15.4172C59.0967 15.7581 59.6142 16.6544 59.4751 17.5771L58.8195 21.9265C58.7229 22.5674 58.9429 23.2154 59.4097 23.665L62.5775 26.7166C63.2496 27.3639 63.3846 28.39 62.9031 29.1892L60.6329 32.9567C60.2984 33.5118 60.2537 34.1947 60.5129 34.7887L62.2718 38.8203C62.6449 39.6755 62.3771 40.6752 61.6263 41.2293L58.0872 43.8412C57.5658 44.2261 57.2631 44.8398 57.2752 45.4878L57.3575 49.8857C57.3749 50.8186 56.7449 51.6396 55.8392 51.8642L51.57 52.923C50.9409 53.0791 50.4265 53.5302 50.1897 54.1335L48.5827 58.2281C48.2418 59.0967 47.3455 59.6141 46.4229 59.475L42.0734 58.8195C41.4325 58.7229 40.7845 58.9428 40.3349 59.4096L37.2833 62.5775C36.636 63.2495 35.6099 63.3846 34.8107 62.903L31.0432 60.6329C30.4881 60.2984 29.8053 60.2536 29.2112 60.5128L25.1796 62.2718C24.3244 62.6449 23.3248 62.3771 22.7707 61.6263L20.1587 58.0872C19.7738 57.5657 19.1601 57.2631 18.5121 57.2752L14.1143 57.3574C13.1813 57.3749 12.3603 56.7449 12.1357 55.8392L11.0769 51.57C10.9209 50.9409 10.4697 50.4264 9.86637 50.1896L5.77184 48.5826C4.90325 48.2417 4.3858 47.3455 4.52487 46.4228L5.18043 42.0734C5.27703 41.4325 5.05708 40.7845 4.5903 40.3349L1.42242 37.2833C0.750395 36.6359 0.615316 35.6099 1.09689 34.8107L3.36702 31.0432C3.70152 30.488 3.74627 29.8052 3.4871 29.2112L1.72815 25.1796C1.35501 24.3243 1.62286 23.3247 2.37363 22.7706L5.91272 20.1586C6.43419 19.7738 6.73684 19.1601 6.72472 18.5121L6.64249 14.1142C6.62504 13.1813 7.25504 12.3603 8.16071 12.1357L12.43 11.0768C13.059 10.9208 13.5735 10.4697 13.8103 9.86634L15.4173 5.77181C15.7582 4.90321 16.6544 4.38577 17.5771 4.52484L21.9266 5.1804C22.5674 5.27699 23.2154 5.05704 23.665 4.59026L26.7166 1.42238C27.364 0.750361 28.39 0.615282 29.1892 1.09686L32.9568 3.36699C33.5119 3.70149 34.1947 3.74624 34.7887 3.48706L38.8203 1.72811Z"
            fill="#9C4BE3"
          />
        </svg>
        {children && (
          <div css={[childrenStyle, childrenCSS]} ref={childWrapper}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
